module.exports = __webpack_public_path__ + "media/images/dropdown-opened-3acb7cc7.svg";